import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';
export default function ProgramBasicInfoComponent ({application,applications,onFormChange, selectedProgram}: any) {
const libraryData = useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         <InputContainer

label="Active"
name="IsActive"
onValueChange={(event: any) => {
  onFormChange({
    value: event,
    field: 'IsActive'
  });
}}
type="checkbox"
value={selectedProgram?.IsActive}
/>

<InputContainer

label="Name"
name="Name"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'Name'
  });
}}
type="text"
value={selectedProgram?.Name}
/>
 
<InputContainer

label="Display Order"
name="DisplayOrder"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'DisplayOrder'
  });
}}
type="number"
value={selectedProgram?.DisplayOrder}
/>
 
<InputContainer

label="Always Enabled"
name="IsAlwaysEnabled"
onValueChange={(event: any) => {
  onFormChange({
    value: event,
    field: 'IsAlwaysEnabled'
  });
}}
type="checkbox"
value={selectedProgram?.IsAlwaysEnabled}
/>
 
 <InputContainer
                 label="Program Type"
                 labelField="Text"
                 list={libraryData?.result?.ProgramType}
                 onValueChange={(event: any, newValue: any) => {
                 onFormChange({
                    value: event.target.value,
                    field: 'ProgramTypeId'
                  });
                                }}
                 optionName="Choose ProgramType"
                 type="select"
                 value={selectedProgram?.ProgramTypeId}
                 valueField="Value"
             />
<InputContainer

label="Remarks"
name="Remarks"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'Remarks'
  });
}}
type="text"
value={selectedProgram?.Remarks}
/>

 {selectedProgram.IsAlwaysEnabled !== true &&

                <><InputContainer

                label="Start Date"
                name="StartDateUtc"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'StartDateUtc'
                  });
                } }
                type="date"
                value={selectedProgram?.StartDateUtc} /><InputContainer

                  label="End Date"
                  name="EndDateUtc"
                  onValueChange={(event: any) => {
                    onFormChange({
                      value: event.target.value,
                      field: 'EndDateUtc'
                    });
                  } }
                  type="date"
                  value={selectedProgram?.EndDateUtc} /></>
              } 
<InputContainer

label="Description"
name="Description"
onValueChange={(event: any) => {
  onFormChange({
    value: event.target.value,
    field: 'Description'
  });
}}
type="text"
value={selectedProgram?.Description}
/>
</div>
}
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}